<!--
 * @Desc: 网站首页
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-07 10:27:04
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-index">
        <!-- 菜单 -->
        <menuCommon :active="'0'"></menuCommon>
        <!-- 内容区 -->
        <!-- 轮播图 -->
        <bannerCommon></bannerCommon>
        <!-- 新闻 -->
        <!-- <newsCommon></newsCommon> -->
        <!-- 学校新闻 -->
        <schoolNews :listData="homeArticleData[1]"></schoolNews>
        <!-- 学校概况 -->
        <schoolProfile :listData="homeArticleData[0]"></schoolProfile>
        <!-- 教育教学 -->
        <!-- <educationTeach></educationTeach> -->
        <!-- 智慧学校 -->
        <!-- <noticeCommon></noticeCommon> -->
        <!-- 师资队伍 -->
        <teachersCommon :listData="homeArticleData[2]"></teachersCommon>
        <!-- 校园风光 -->
        <campusScenery :listData="homeArticleData[3]"></campusScenery>
        <!-- 报名申请 -->
        <applyCommon></applyCommon>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
        <!-- 返回顶部 -->
        <!-- <div class="nav-hold">
            <div class="nav-top"><img class="thu" src="../../public/statics/images/arr.png"></div>
        </div> -->
    </div>
</template>

<script>
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import bannerCommon from "./../components/Index/Banner.vue";
import applyCommon from "./../components/Index/Apply.vue";
import newsCommon from "./../components/Index/News.vue";
import schoolProfile from "./../components/Index/SchoolProfile.vue";
import schoolNews from "./../components/Index/SchoolNews.vue";
import noticeCommon from "./../components/Index/Notice.vue";
import teachersCommon from "./../components/Index/Teachers.vue";
import educationTeach from "./../components/Index/EducationTeach.vue";
import campusScenery from "./../components/Index/CampusScenery.vue";
export default {
    name: "home",
    data() {
        return {
            homeArticleData:[]
        };
    },
    components: {
        menuCommon,
        footerCommon,
        bannerCommon,
        applyCommon,
        newsCommon,
        schoolProfile,
        schoolNews,
        noticeCommon,
        teachersCommon,
        educationTeach,
        campusScenery
    },
    created() {
        // this.Cookies.set('theme', 909, { expires: 365 })
        // console.log(this.Cookies.get('theme'))
    },
    mounted() {
        this.homeArticle()
    },
    beforeDestroy() {
    },
    methods: {
        // 首页新闻
        homeArticle(){
            let that = this
            that.$api.index.homeArticle({}).then((res) => {
                if (res.code == 200) {
                    that.homeArticleData = res.result
                }
            })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>